class MainProduct extends HTMLElement {
  constructor() {
    super();
    this.data = this.querySelector("#product-json");
    this.variantListeners = this.querySelectorAll("[data-variant-listener]");
    this.freeShipping = this.querySelector("#product-form__free-shipping");
    this.productId = this.dataset.productId;
    this.inputSubscriptionIntervalOverride = "";
    this.inputSubscriptionIntervalTypeOverride = "";
    this.subProgram = this.querySelector("subscription-program-v2");
    this.replacementProductModalOpenerButton = this.querySelector(
      ".replacement_product__modal-opener button"
    );
    this.amazonContainers = this.querySelectorAll(".amazon-link");
    this.deliverTextWrapper = this.querySelector("delivery-text");
    this.deliveryWrapper = this.querySelector("expected-delivery");
    this.preorderData = parseJSON(this.dataset.inventoryPreorder, []);
    this.notifyPreorder = this.querySelector(".preorder-notify");
    this.StickyAddToCartWrap = this.querySelector(".pdp-add-to-cart__wrap");
    try {
      const sellingPlanText = this.querySelector("#selling-plan-json");
      if (sellingPlanText)
        this.sellingPlanJson = JSON.parse(sellingPlanText.textContent);
      else this.sellingPlanJson = [];
    } catch (e) {
      this.sellingPlanJson = [];
    }
    try {
      this.fallBackOptions = JSON.parse(this.dataset.fallbackOptions);
    } catch (e) {
      this.fallBackOptions = null;
    }
    this.percentageInfo = this.querySelectorAll("[data-percent]");
    this.variantOptions = this.querySelectorAll(`[data-variant-option]`);
    this.subOption = this.querySelector(
      `product-options[data-subscription-option]`
    );
    this.disabledOptions = this.querySelector(
      "#disabled-options-" + this.productId
    );
    this.modelButton = this.querySelector(".view-3d-modal__icon");
    this.benefitsContainers =
      this.querySelectorAll(
        `[data-product-benefits="benefits-${this.productId}"]`
      ) || [];
    this.productForm = this.querySelector('[data-product-form="true"]');
    this.mediaContainers = Array.from(
      this.querySelectorAll(
        `[data-product-media="media-${this.productId}"] img`
      )
    );
    this.quantitySelector = this.querySelector("quantity-input");
    this.quantity = 1;
    this.priceContainers = this.querySelectorAll(
      `[data-product-price="price-${this.productId}"]`
    );
    this.pricePerMonthContainers = this.querySelectorAll(
      `[data-product-price-pm="price-pm-${this.productId}"]`
    );
    this.intervalOptionSelect = this.querySelector(
      "subscription-interval-selector"
    );
    this.inputSubscriptionInterval = this.querySelector(
      `#subscription-option-${this.productId}:not([data-sub-program="true"])`
    );
    this.intervalSubscriptionWrapper = this.querySelector(
      `[data-subscription-interval="sub-interval-${this.productId}"]`
    );
    this.comparePriceContainers = this.querySelectorAll(
      `[data-product-compare-price="compare-price-${this.productId}"]:not(.grp-price)`
    );
    this.variantTitlesContainers = this.querySelectorAll(
      `[data-variant-title="variant-title-${this.productId}"]`
    );
    this.bundleContainers = this.querySelectorAll("[data-bundle-save]");
    this.saveContainers = this.querySelectorAll(
      "[data-save-percent-container]"
    );
    this.subPriceContainers = this.querySelectorAll(
      `[data-product-sub-price="sub-price-${this.productId}"]`
    );
    this.otpContainers = this.querySelectorAll(
      `[data-product-price-otp="otp-price-${this.productId}"]`
    );
    this.subscriptionProgramV2 = this.querySelector("subscription-program-v2");
    if (
      this.subscriptionProgramV2 &&
      this.subscriptionProgramV2.parentElement.children.length > 1
    ) {
      if (document.body.dataset.grp) {
        this.subscriptionProgramV2 = this.querySelector(
          "subscription-program-v2[data-hide='true']"
        );
      } else {
        this.subscriptionProgramV2 = this.querySelector(
          "subscription-program-v2:not([data-hide='true'])"
        );
      }
    }
    this.comparePricePercentageOff = this.querySelector(
      "[data-save-percent-compare]"
    );
    this.savePercentageContainer = this.querySelector(
      "[data-save-percent-container]"
    );
    this.spaceBetweenPrices = this.querySelector("[data-space-between-prices]");
    this.priceWrapper = this.querySelector("[data-price-wrapper]");
    this.load();
  }

  load() {
    try {
      this.data = this.querySelector("#product-json");
      this.productData = JSON.parse(this.data.textContent);
      this.pdpCarousel = this.querySelector("custom-carousel");
      this.previewMediaContainer = this.querySelectorAll(
        "[data-product-preview-media] img"
      );
      this.updateOptions();
      this.updateDisabledOptions();
      this.getAvailableVariants();
      this.addListeners();
    } catch (e) {
      this.productData = null;
    }
  }
  showReplacementProductModal(result) {
    if (
      !this.replacementProductModalHasShown &&
      !result.available &&
      this.replacementProductModalOpenerButton
    ) {
      this.replacementProductModalOpenerButton.click();
      this.replacementProductModalHasShown = true;
    }
  }
  overrideSubscriptionInterval(interval, intervalType) {
    this.inputSubscriptionIntervalOverride = interval;
    this.inputSubscriptionIntervalTypeOverride = intervalType;
    this.dispatchEvent(new CustomEvent("change"));
  }
  updateDisabledOptions() {
    if (this.disabledOptions) {
      if (!this.disabledOptionsData) {
        this.disabledOptionsData = JSON.parse(this.disabledOptions.textContent);
        if (this.fallBackOptions) {
          const cache = [];
          this.disabledOptionsData.filter((options, index) => {
            const otherFallBackOptions = this.fallBackOptions.filter(
              (i) => options.indexOf(i) === -1
            );
            const nonFallBackOptions = options.filter(
              (i) => this.fallBackOptions.indexOf(i) === -1
            );
            this.disabledOptionsData.forEach((option) => {
              if (
                option.every(
                  (o) =>
                    otherFallBackOptions.indexOf(o) !== -1 ||
                    nonFallBackOptions.indexOf(o) !== -1
                )
              ) {
                cache.push(option);
              }
            });
          });
          this.disabledOptionsData = cache;
        }
      }

      let disabled = this.getDisabledOptions().flat() || [];

      this.variantOptions.forEach((node) => {
        const label = document.querySelector(`label[for="${node.id}"]`);
        const textLabel = label
          ?.closest(".product-options-shades__wrapper")
          ?.querySelector(".radio-swatches__label");
        const isDisabled = disabled.find(
          (j) => j.toLowerCase().trim() === node.value.toLowerCase().trim()
        );
        if (isDisabled && node.dataset.allowDisabling !== "false") {
          const matchingVariants =
            this.productData?.variants?.filter((variant) =>
              variant.options.some(
                (opt) =>
                  opt.toLowerCase().trim() === node.value.toLowerCase().trim()
              )
            ) || [];
          matchingVariants.forEach((variant) => {
            const isExactMatch = this.disabledOptionsData.some(
              (disabledOptionSet) =>
                variant.options.every(
                  (opt, i) =>
                    disabledOptionSet[i].toLowerCase().trim() ===
                    opt.toLowerCase().trim()
                )
            );
            if (
              (variant.sku === null ||
                variant.sku.toLowerCase() === "not_sold") &&
              isExactMatch
            ) {
              label?.classList.add("hidden");
              textLabel?.classList.add("hidden");
            }
          });
          node.setAttribute("data-oos", true);
        }
      });

      const patternWrapper = this.querySelector(".swatch-group.patterns");
      if (patternWrapper) {
        const patternSwatches = patternWrapper.querySelectorAll(
          'input[data-swatch-type="pattern"]'
        );
        if (!patternSwatches.length) return;

        const allPatternHidden = Array.from(patternSwatches).every(
          (sw) => sw.dataset.oos === "true"
        );

        const titleDiv = patternWrapper.querySelector(
          ".product-options__title"
        );
        if (titleDiv) {
          if (allPatternHidden) {
            titleDiv.classList.add("hidden");
          } else {
            titleDiv.classList.remove("hidden");
          }
        }
      }
    }
  }
  getDisabledOptions() {
    const disabled = [];
    if (this.optionsValues.length < 2) {
      this.disabledOptionsData.forEach((i) => disabled.push(i));
    } else {
      this.optionsValues.forEach((option) => {
        const otherSelectedOptions = this.optionsValues.filter(
          (i) => i !== option
        );
        this.disabledOptionsData.forEach((j) => {
          if (
            otherSelectedOptions.every((i) => {
              return j.indexOf(i) !== -1;
            })
          ) {
            disabled.push(
              j.filter((l) => otherSelectedOptions.indexOf(l) === -1)
            );
          }
        });
      });
    }
    return disabled;
  }

  onVariantChange(evt) {
    if (!this.data) {
      return;
    }
    this.updateOptions();
    if (this.subOption || this.subscriptionProgramV2) {
      this.updateSubOptions();
    }
    this.getCurrentVariant(evt);
    this.updateInstallmentInput();
    if (this.intervalOptionSelect) {
      this.intervalOptionSelect.updateIntervalValue(evt, this.currentVariant);
    }
    this.updateUrl();
    this.updatePrices();
    if (this.productForm) {
      this.updateForm();
    }
    this.resetOverrideIntervalValues();
    this.updateBadges();
  }

  updateBadges() {
    const badgeHtml = this.currentVariant.badge;
    const discountTitleBadge = this.querySelector(".variant-title__discount");
    const discountTitle = this.currentVariant.discount_title;

    if (discountTitleBadge) {
      if (discountTitle) {
        discountTitleBadge.textContent = discountTitle;
        discountTitleBadge.classList.remove("hide");
      } else {
        discountTitleBadge.classList.add("hide");
      }
    }

    const wrappers_alt = this.querySelectorAll(
      ".product-options__subscription-wrapper--alt, " +
      ".product-options__label.otp"
    );

    const wrappers = this.querySelectorAll(
      ".product-options__subscription-option-wrapper:not(.otp), " +
      ".product-options__subscription-option-wrapper.otp"
    )

    const badgeSelector = ".sub__percent-label.text-bold.w-fit-content";

    wrappers.forEach(wrapper => {
      if (!wrapper) return;
      const badges = wrapper.querySelectorAll(badgeSelector);
      badges.forEach(badge => {
        if (!badge) return;

        if (badgeHtml) {
          badge.classList.remove("hide");
        } else {
          badge.classList.add("hide");
        }
      });
    });

    wrappers_alt.forEach((wrapper) => {
      if (!wrapper) return;

      const badges = wrapper.querySelectorAll(badgeSelector);
      if (!badges || badges.length === 0) return;

      badges.forEach((el) => {
        if (el && el.classList.contains("sub__percent-label")) {
          el.remove();
        }
      });
    });

    if (!badgeHtml || typeof badgeHtml !== "string") return;

    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = badgeHtml.trim();
    const badgeEl = tempDiv.firstElementChild;
    if (!badgeEl) return;

    wrappers_alt.forEach((wrapper) => {
      if (!wrapper) return;
      wrapper.prepend(badgeEl.cloneNode(true));
    });
  }

  getAvailableVariants() {
    this.availableVariants = [];
    this.productData.variants.forEach((variant) => {
      if (variant.available) {
        this.availableVariants.push(variant.options);
      }
    });
  }

  addListeners() {
    this.addEventListener("change", this.onVariantChange);
    if (this.quantitySelector) {
      this.quantitySelector.addEventListener(
        "change",
        this.updatePrices.bind(this)
      );
    }
  }

  updateSubOptions() {
    const selectedSubOption =
      this.subOption &&
      this.subOption.querySelector(
        'input:checked[data-type="option"]:not([data-simple=true]):not([data-alternate="true"])'
      );
    if (selectedSubOption && selectedSubOption.dataset) {
      this.isSubProgramV2 = !!selectedSubOption.dataset.subProgramV2;
    }
    if (!this.isSubProgramV2 && this.subscriptionProgramV2) {
      this.subscriptionProgramV2.updateForm();
    } else {
      if (!this.subValue) {
        this.productForm.querySelector('[name="selling_plan"]') &&
          (this.productForm.querySelector('[name="selling_plan"]').value = "");
      }
      this.subValue = selectedSubOption.value;
      if (this.subscriptionProgramV2) {
        this.subscriptionProgramV2.updateForm();
      }
    }
    if (this.productForm && !this.subscriptionProgramV2) {
      this.productForm.querySelector('[name="properties[_interval]"]').value =
        this.subValue;
    }
  }
  updateOptions() {
    this.optionsNodes = this.querySelectorAll(
      "input:checked[data-variant-option],select[data-variant-option]"
    );
    if (this.optionsNodes) {
      this.optionsValues = Array.from(this.optionsNodes).map((i) => i.value);
      this.optionsIndexes = Array.from(this.optionsNodes).map(
        (i) => i.dataset.optionIndex
      );
      return;
    }
    this.optionsValues = [];
  }

  getCurrentVariant(evt) {
    let result = this.productData.variants.find((variant) => {
      return this.optionsValues.every((option, index) => {
        const optionIndex = this.optionsIndexes[index];
        return variant.options[optionIndex - 1] == option;
      });
    });

    const selectedOption = this.querySelector('input[type="radio"]:checked');
    const selectedValue = selectedOption?.value?.trim().toLowerCase();
    const optionPosition = parseInt(this.dataset.optionIndex, 10) || 0;
    const selectedIndex = optionPosition
      ? parseInt(optionPosition.replace("option", ""), 10) - 1
      : 0;
    const isDiscontinued =
      !result?.sku || result.sku.toLowerCase() === "not_sold";

    if (!result || isDiscontinued) {
      let fallbackVariant = this.productData.variants.find(
        (variant) =>
          variant.available &&
          variant.options[selectedIndex]?.trim().toLowerCase() === selectedValue
      );
      if (!fallbackVariant) {
        fallbackVariant = this.productData.variants.find((v) => v.available);
      }

      if (fallbackVariant) {
        result = fallbackVariant;

        this.variantOptions.forEach((node) => {
          const optionPosition = node.dataset.optionPosition;
          const optionIndex =
            parseInt(optionPosition.replace("option", ""), 10) - 1;
          const variantValue = fallbackVariant.options[optionIndex]
            ?.trim()
            .toLowerCase();
          const nodeValue = node.value?.trim().toLowerCase();

          const shouldBeChecked = variantValue === nodeValue;

          if (node.checked !== shouldBeChecked) {
            node.checked = shouldBeChecked;
            if (shouldBeChecked)
              node.dispatchEvent(new Event("change", { bubbles: true }));
          }
        });
        this.updateDisabledOptions();
      }
    }
    if (this.fallBackOptions && !result.available) {
      const otherOptions = this.optionsValues.filter(
        (option) => this.fallBackOptions.indexOf(option) === -1
      );
      const otherFallbackOptions = this.fallBackOptions.filter(
        (i) => this.optionsValues.indexOf(i) === -1
      );
      result = this.productData.variants.find((variant) => {
        for (let o = 0; o < otherFallbackOptions.length; o++) {
          const optionsSearch = [...otherOptions, otherFallbackOptions[o]];
          if (
            optionsSearch.every(
              ((op) => variant.options.indexOf(op) !== -1) ||
                o === otherFallbackOptions.length - 1
            )
          ) {
            return true;
          }
        }
      });
    }
    this.showReplacementProductModal(result);
    if (!result) {
      this.updateOptionsData(false);
      return;
    }
    if (
      !this.currentVariant ||
      (this.currentVariant && this.currentVariant.id !== result.id)
    ) {
      this.currentVariant = result;
    }
    this.querySelectorAll('[data-value="blurb"]').forEach((node) => {
      node.innerHTML = this.currentVariant.blurb;
    });
    this.querySelectorAll(".product-card__description").forEach((node) => {
      node.innerHTML = this.currentVariant.short_blurb;
    });
    this.handleSellingPlanSelect();
    this.handleDelayedVariant();
    if (this.variantTitlesContainers.length)
      this.variantTitlesContainers.forEach((node) => {
        let delimiter = "<span class='divider'>•</span>";
        let variant_text = "";
        variant_text = this.currentVariant.title
          .split(" / ")
          .map((item, index) => {
            return `<span class='variant-title__item'>${item}</span> `;
          })
          .join(delimiter);
        node.innerHTML = variant_text;
      });
    if (this.variantListeners) {
      this.variantListeners.forEach((j) =>
        j.setAttribute(j.dataset.variantListener, this.currentVariant.id)
      );
    }
    if (this.benefitsContainers.length) {
      const current_benefits = this.currentVariant.top_benefits || null;
      this.benefitsContainers.forEach((node) => {
        node.innerHTML = current_benefits;
      });
    }
    if (this.modelButton) {
      const model =
        this.productData &&
        this.productData.models.length &&
        this.productData.models.find((modelItem) =>
          this.currentVariant.options.find(
            (option) =>
              modelItem &&
              modelItem.alt &&
              modelItem.alt.toLowerCase().includes("_" + option.toLowerCase())
          )
        );
      if (!model) {
        this.modelButton.classList.add("hidden");
      } else {
        this.modelButton.classList.remove("hidden");
      }
    }
    if (evt.target.dataset.color) {
      this.dispatchEvent(
        new CustomEvent("color-change", {
          detail: { color: evt.target.value, bubbles: false },
        })
      );
    }
    if (evt.target.dataset.variantOption === "true") {
      if (evt.target.dataset.changePdpMedia === "true") {
        if (this.previewMediaContainer) {
          this.changePreviewMedia();
        }
        if (this.pdpCarousel) {
          this.changeMediaPDP();
        }
      }
      this.updateOptionsData(this.currentVariant.available);
      const preorderMeta = this.preorderData[this.currentVariant?.id];
      this.dispatchEvent(
        new CustomEvent("variant-change", {
          detail: {
            currentVariant: this.currentVariant,
            shouldChangePdpMedia: evt.target.dataset.changePdpMedia === "true",
            preorderMeta: preorderMeta,
          },
          bubbles: false,
        })
      );
    }
  }
  updateInstallmentInput() {
    const installmentInput = this.querySelector(".installment-variant-id");
    if (!installmentInput || !this.currentVariant) return;

    if (installmentInput.value !== String(this.currentVariant.id)) {
      installmentInput.value = this.currentVariant.id;
      installmentInput.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  updateOptionsData(available) {
    let marketAvailability = true;
    if (this.productForm)
      marketAvailability =
        this.productForm
          .querySelector("button")
          .getAttribute("data-market-availability") !== "false";
    if (this.productForm && marketAvailability) {
      this.productForm
        .querySelectorAll("button.product-form__submit")
        .forEach((i) => i.removeAttribute("disabled"));
      this.productForm
        .querySelectorAll("[data-upsell-modal]")
        .forEach((i) => i.removeAttribute("disabled"));
    }
    if (!this.optionsNodes.length) return;
    this.variantOptions.forEach((option) => {
      option.removeAttribute("data-oos");
      const label = document.querySelector(`label[for="${option.id}"]`);
      const textLabel = label
        ?.closest(".product-options-shades__wrapper")
        ?.querySelector(".radio-swatches__label");
      label?.classList.remove("hidden");
      textLabel?.classList.remove("hidden");
    });
    if (!available) {
      this.optionsNodes.forEach((i) => {
        i.dataset.allowDisabling !== "false" &&
          i.setAttribute("data-oos", true);
        if (i.tagName.toLowerCase() === "select") {
          let disabled = this.getDisabledOptions().flat() || [];
          let options = Array.prototype.slice.call(i.childNodes);
          options.forEach((k) => {
            if (!k.value) return;
            if (disabled.includes(k.value.toLowerCase().trim())) {
              k.setAttribute("data-oos", true);
            }
          });
        }
      });
      if (this.productForm) {
        this.productForm.querySelectorAll("button").forEach((btn) => {
          btn.disabled = true;
          const text = btn.querySelector("[data-current-price]");
          const pricesSeparator = btn.querySelector("i");
          if (pricesSeparator) {
            pricesSeparator.classList.add("hidden");
          }
          if (text) {
            text.innerText = theme.translations.sold_out;
          }
          this.classList.add("variant--oos");
          if (this.deliveryWrapper) {
            this.hideElement(this.deliveryWrapper);
          }
        });
      }
    } else {
      if (this.productForm) {
        this.productForm.querySelectorAll("button").forEach((btn) => {
          btn.disabled = false;
          const pricesSeparator = btn.querySelector("i");
          if (pricesSeparator) {
            pricesSeparator.classList.remove("hidden");
          }
          this.classList.remove("variant--oos");
        });
        if (this.deliveryWrapper) {
          this.showElement(this.deliveryWrapper);
        }
      }
    }
    this.updateDisabledOptions();
  }
  changePreviewMedia() {
    if (!this.currentVariant) return;
    if (this.currentVariant.featured_media) {
      if (this.previewMediaContainer) {
        this.previewMediaContainer.forEach((img) => {
          const mediaQuery = img.src.split("?")[1] || "";
          img.srcset = `${this.currentVariant.featured_media.preview_image.src}?${mediaQuery}`;
          img.alt = this.currentVariant.featured_media.preview_image.alt;
        });
      }
    }
  }
  changeMediaPDP() {
    const mediaChangeEvent = new CustomEvent("media-change", {
      detail: {
        media: [
          ...this.currentVariant.media,
          ...this.productData.images_no_variants,
        ],
        media_alt: [
          ...this.currentVariant.media_alt,
          ...this.productData.images_no_variants.map((i) => "product alt"),
        ],
      },
    });
    this.dispatchEvent(mediaChangeEvent);
  }

  updatePrices() {
    if (!this.currentVariant) return;
    if (this.quantitySelector)
      this.quantity = this.quantitySelector.getQuantity();
    const subscriptionDiscount =
      (this.currentVariant.price * this.productData.subscription_discount) /
      100;
    let currentVariantPrice;

    if (this.subscriptionProgramV2) {
      currentVariantPrice = this.currentVariant.price;
    } else {
      if (this.currentSellingPlan) {
        currentVariantPrice = this.subValue
          ? parseFloat(this.currentSellingPlan.selling_plan_price)
          : this.currentVariant.price;
      } else {
        currentVariantPrice = this.subValue
          ? this.currentVariant.price - subscriptionDiscount
          : this.currentVariant.price;
      }
    }
    let discountedVariantPrice = Math.round(
      this.currentVariant.price - subscriptionDiscount
    );
    if (this.currentSellingPlan) {
      discountedVariantPrice = parseFloat(
        this.currentSellingPlan.selling_plan_price
      );
    }
    this.currentVariantPrice = currentVariantPrice;
    const savePercentage =
      100 -
      Math.round(
        (this.currentVariantPrice * 100) / this.currentVariant.compare_at_price
      );
    if (!this.subProgram) {
      if (savePercentage > 0) {
        this.savePercentageContainer?.classList?.remove("hidden");
        this.comparePricePercentageOff &&
          (this.comparePricePercentageOff.innerText = savePercentage);
      } else {
        this.savePercentageContainer?.classList?.add("hidden");
      }
    }

    const totalPrice = currentVariantPrice * this.quantity;
    if (this.freeShipping) this.handleFreeShipping(totalPrice);
    this.dispatchEvent(
      new CustomEvent("productPriceChange", { detail: totalPrice })
    );
    this.handlePercentageInfo();
    this.priceContainers.forEach((i) => {
      if (this.isSubProgramV2) {
        this.currentVariantPrice =
          parseFloat(
            this.subscriptionProgramV2?.selectedOffer?.dataset?.programPrice
          ) || this.currentVariant.price;
        return;
      }
      if (i.dataset.formItem === "true" && !this.currentVariant.available) {
        i.innerText = theme.translations.sold_out;
        this.classList.add("variant--oos");
      } else {
        i.innerHTML = formatMoney(currentVariantPrice).toUpperCase();
        if (this.currentVariant.available) {
          this.classList.remove("variant--oos");
        }
      }
    });
    this.subPriceContainers.forEach((node) => {
      if (!this.isSubProgramV2) {
        node.innerText = formatMoney(discountedVariantPrice);
      }
    });
    this.otpContainers.forEach((node) => {
      node.innerText = formatMoney(this.currentVariant.price);
    });
    this.pricePerMonthContainers.forEach((node) => {
      const subscriptionInterval = this.getSubscriptionInterval();
      let variantPrice = this.currentVariant.subscription_variant_price;
      if (
        this.currentSellingPlan &&
        this.currentSellingPlan.selling_plan_price
      ) {
        variantPrice = this.currentSellingPlan.selling_plan_price;
      }
      let priceSubItems = 0;
      if (this.currentVariant.subscription_variant_selling_plans_total) {
        priceSubItems =
          this.currentVariant.subscription_variant_selling_plans_total;
      } else {
        if (variantPrice) {
          if (
            this.currentSellingPlan &&
            this.currentSellingPlan.selling_plan_price
          ) {
            priceSubItems = this.currentSellingPlan.selling_plan_price;
          } else {
            const subDiscount =
              (variantPrice * this.productData.subscription_discount) / 100;
            priceSubItems = variantPrice - subDiscount;
          }
        }
      }
      node.innerText = formatMoney(priceSubItems / subscriptionInterval);
    });

    if (
      this.currentVariant.subscription_interval &&
      this.intervalSubscriptionWrapper
    ) {
      this.intervalSubscriptionWrapper.innerText =
        this.getSubscriptionInterval();
    }
    if (
      this.currentVariant.subscription_interval_type &&
      this.inputSubscriptionInterval
    ) {
      this.inputSubscriptionInterval.value =
        this.getSubscriptionIntervalWithType();
    }
    if (
      this.inputCardSubscriptionInterval &&
      this.currentVariant.subscription_interval_type
    ) {
      this.inputCardSubscriptionInterval.value =
        this.getSubscriptionIntervalWithType();
    }
    if (this.subOption) {
      this.subOption
        .querySelectorAll("[data-product-save]")
        .forEach(
          (s) =>
            (s.innerHTML = formatMoney(
              this.currentVariant.price - discountedVariantPrice
            ).toUpperCase())
        );
    }
    this.comparePriceContainers.forEach((container) => {
      if (!this.currentVariant || !this.currentVariant.available) {
        container.classList.add("hidden");
        return;
      }
      if (
        this.currentVariant.compare_at_price <= this.currentVariant.price &&
        container.dataset.otpComparePrice === "true"
      ) {
        container.classList.add("hidden");
        return;
      }
      if (this.currentVariant.compare_at_price > this.currentVariantPrice) {
        if (!this.StickyAddToCartWrap?.classList.contains("active")) {
          container.classList.remove("hidden");
        }
        container.innerText = formatMoney(this.currentVariant.compare_at_price);
      } else if (container.dataset.subComparePrice === "true") {
        container.innerText = formatMoney(this.currentVariant.compare_at_price);
        return;
      } else {
        container.classList.add("hidden");
      }
    });

    let amount = 0;
    const InitialTotalPrice =
      this.currentVariant.compare_at_price ||
      this.currentVariant.bundle_total_price ||
      this.currentVariant.price;
    amount = 100 - Math.round((currentVariantPrice * 100) / InitialTotalPrice);
    if (amount === 0) {
      this.dataSaveComparePercentContainer?.classList.add("hidden");
    } else if (this.comparePricePercentageOff) {
      this.comparePricePercentageOff.innerText = amount;
    }
    this.bundleContainers.forEach((node) => {
      node.innerText = amount;
    });
  }

  handleFreeShipping(totalPrice) {
    if (totalPrice > theme.shop.free_shipping * 100) {
      this.freeShipping.classList.replace("d-none", "d-flex");
    } else {
      this.freeShipping.classList.replace("d-flex", "d-none");
    }
  }
  updateForm() {
    if (!this.productForm || !this.currentVariant) return;
    this.productForm.querySelector("input[name='id']").value =
      this.currentVariant.id;
    if (
      this.subOption &&
      this.currentVariant.subscription_interval_type &&
      this.productForm &&
      !this.subscriptionProgramV2
    ) {
      const selectedSubOption = this.subOption.querySelector(
        'input:checked[data-type="option"]:not([data-simple=true])'
      );
      this.productForm.querySelector('[name="properties[_interval]"]').value =
        selectedSubOption.value;
      if (
        this.currentSellingPlan &&
        this.currentSellingPlan.selling_plan_id &&
        this.subValue
      ) {
        this.productForm.querySelector(
          '[name="properties[_interval]"]'
        ).value = `${this.currentSellingPlan.interval_count}${this.currentSellingPlan.interval}`;
      }
      const sellingPlanInput = this.productForm.querySelector(
        '[name="selling_plan"]'
      );
      const sellingPlanProperty = this.productForm.querySelector(
        '[name="properties[_selling_plan]"]'
      );
      if (
        this.currentSellingPlan &&
        this.currentSellingPlan.selling_plan_id &&
        selectedSubOption.value &&
        sellingPlanInput &&
        !this.isSubProgramV2
      ) {
        sellingPlanInput.value = this.currentSellingPlan.selling_plan_id;
        sellingPlanProperty &&
          (sellingPlanProperty.value = this.currentSellingPlan.selling_plan_id);
      } else {
        sellingPlanInput.value =
          selectedSubOption.value && sellingPlanProperty.value
            ? sellingPlanProperty.value
            : "";
      }
    }
  }

  updateUrl() {
    const url = new URL(window.location.href);
    if (this.currentVariant && this.currentVariant.id)
      url.searchParams.set("variant", this.currentVariant.id);
    history.replaceState({ path: url.toString() }, "", url.toString());
  }
  getSubscriptionInterval() {
    let subscriptionInterval = this.currentVariant.subscription_interval
      ? this.currentVariant.subscription_interval
      : this.productData.subscription_interval;
    return this.inputSubscriptionIntervalOverride || subscriptionInterval;
  }
  getSubscriptionIntervalWithType() {
    let subscriptionIntervalType = this.currentVariant
      .subscription_interval_type
      ? this.currentVariant.subscription_interval_type
      : this.productData.subscription_interval_type;
    const intervalSelector = this.querySelector(
      "subscription-interval-selector"
    );
    if (intervalSelector && intervalSelector.style.display !== "none") {
      this.customInterval = intervalSelector.querySelector(
        "select.product-options__interval-select"
      );
    }
    return this.customInterval && this.customInterval.value
      ? this.customInterval.value
      : this.inputSubscriptionIntervalTypeOverride || subscriptionIntervalType;
  }
  resetOverrideIntervalValues() {
    this.inputSubscriptionIntervalOverride = "";
    this.inputSubscriptionIntervalTypeOverride = "";
  }
  handleDelayedVariant() {
    const delayedMeta = this.preorderData[this.currentVariant.id];
    const submitButton = this.querySelector(".product-form__submit");
    const otpInput = this.querySelector("input[id^='otp-option-']");

    if (delayedMeta) {
      if (delayedMeta.hide_amazon === "true") {
        this.amazonContainers.forEach((container) => {
          container.classList.add("hidden");
        });
      }
      this.isPreorder = delayedMeta.preorder;
      if (this.isPreorder) {
        if (this.subOption) {
          this.hideElement(this.subOption);
          this.clickIfExists(
            this.subOption.querySelector("input[id^='otp-option-']")
          );
        }
        if (this.subscriptionProgramV2) {
          this.hideElement(this.subscriptionProgramV2);
          this.clickIfExists(otpInput);
        }
        if (submitButton) {
          submitButton.classList.add("preorder");
        }
        if (this.notifyPreorder) {
          this.notifyPreorder.classList.remove("hidden");
        }
      } else {
        this.amazonContainers.forEach((container) => {
          container.classList.remove("hidden");
        });
        if (submitButton) {
          submitButton.classList.remove("preorder");
        }
        if (this.subOption) {
          this.showElement(this.subOption, "flex");
        }
        if (this.subscriptionProgramV2) {
          this.showElement(this.subscriptionProgramV2);
        }
        if (this.notifyPreorder) {
          this.notifyPreorder.classList.add("hidden");
        }
      }
    } else {
      if (submitButton) {
        submitButton.classList.remove("preorder");
      }
      if (this.subOption) {
        this.showElement(this.subOption, "flex");
      }
      if (this.subscriptionProgramV2) {
        this.showElement(this.subscriptionProgramV2);
      }
      if (this.notifyPreorder) {
        this.notifyPreorder.classList.add("hidden");
      }
    }
  }

  hideElement(el) {
    el.style.display = "none";
  }

  showElement(el, display = "block") {
    el.style.display = display;
  }

  clickIfExists(el) {
    if (el) el.click();
  }
  handleSellingPlanSelect() {
    const interval =
      this.inputSubscriptionIntervalOverride ||
      this.currentVariant.subscription_interval;
    if (this.sellingPlanJson && interval) {
      const selectedPlan = this.sellingPlanJson.find((plan) => {
        return (
          plan[this.currentVariant.id] &&
          plan[this.currentVariant.id].interval_count == interval
        );
      });
      if (selectedPlan && this.currentVariant.id) {
        this.currentSellingPlan = selectedPlan[this.currentVariant.id];
      } else {
        this.currentSellingPlan = "";
      }
    }
  }

  handlePercentageInfo() {
    if (!this.currentSellingPlan || !this.currentSellingPlan.selling_plan_price)
      return;
    const currentPercentage = Math.round(
      (1 -
        this.currentSellingPlan.selling_plan_price /
          this.currentVariant.price) *
        100
    );
    this.percentageInfo.forEach((node) => {
      node.innerHTML = currentPercentage;
    });
  }
}

if (!customElements.get("main-product")) {
  customElements.define("main-product", MainProduct);
}

class ProductVariantSelects extends MainProduct {
  constructor() {
    super();
    this.updateRelatedOptions = this.dataset.updateRelatedOptions;
    this.includedInBox = this.querySelector(".included_in_box");
  }
  load() {
    this.productData = null;
    if (this.dataset.productDetail) {
      const json = this.querySelector("#" + this.dataset.productDetail);
      try {
        this.productData = JSON.parse(json.textContent);
        this.variantsData = this.productData.variants;
      } catch (e) {
        logger.error(`Component Product error:${e}`);
      }
    }
    this.urlContainers = this.querySelectorAll(
      `[data-product-url="url-${this.productId}"]`
    );
    this.inputCardSubscriptionInterval = this.querySelector(
      `[id^="subscription-option-${this.productId}"]`
    );
    this.updateOptions();
    this.updateDisabledOptions();
    this.addListeners();
  }

  addListeners() {
    this.addEventListener("change", this.onVariantChange);
  }

  async onVariantChange(evt) {
    const submitBtn = this.querySelector(".product-form__submit");
    if (!this.productData) {
      submitBtn && submitBtn.classList.add("loading");
      await this.loadData();
      submitBtn && submitBtn.classList.remove("loading");
      this.getAvailableVariants();
    }
    if (this.variantsData) {
      this.updateOptions();
      if (this.subOption) {
        this.updateSubOptions();
      }
      this.getCurrentVariant(evt);
      if (this.intervalOptionSelect) {
        this.intervalOptionSelect.updateIntervalValue(evt, this.currentVariant);
      }
      this.updatePrices();
      this.updateMedia();
      this.updateIncluded();
      this.updateForm();
      this.updateURL();
      this.updateRelatedOption(evt.target.value);
    }
  }

  async loadData() {
    await apiFetchText(`${this.dataset.url}`, "?view=product-json").then(
      (responseText) => {
        const html = new DOMParser()
          .parseFromString(responseText, "text/html")
          .querySelector("#product-json");
        try {
          this.productData = JSON.parse(html.textContent);
          this.variantsData = this.productData.variants;
        } catch (e) {
          this.productData = null;
        }
      }
    );
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (this.currentVariant.featured_media) {
      let _this = this;
      if (this.mediaContainers) {
        this.mediaContainers.forEach((i) => {
          const mediaQuery = i.src.split("?")[1] || "";
          if (
            i.classList.contains("product-card__hover-asset") &&
            this.currentVariant.hover_media
          ) {
            i.srcset = `${this.currentVariant.hover_media.src}?${mediaQuery}`;
            i.alt = this.currentVariant.hover_media.alt;
          } else {
            i.srcset = `${this.currentVariant.featured_media.preview_image.src}?${mediaQuery}`;
            i.alt = this.currentVariant.featured_media.preview_image.alt;
          }
          i.onload = function () {
            i.style.transition = "unset";
            i.style.opacity = 0;
            setTimeout(() => {
              i.style.transition = "opacity .6s ease,transform .5s";
              i.style.opacity = 1;
            }, 200);
          };
        });
      }
    }
  }
  updateIncluded() {
    if (
      !this.currentVariant ||
      !this.currentVariant.whats_in_the_box ||
      !this.includedInBox
    )
      return;
    this.includedInBox.innerHTML = this.currentVariant.whats_in_the_box;
  }
  updateURL() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.available) return;
    if (this.urlContainers.length) {
      this.urlContainers.forEach((i) => {
        i.href = `${this.dataset.url}?variant=${this.currentVariant.id}`;
      });
    }
  }

  updateRelatedOption(optionSelector) {
    if (this.updateRelatedOptions) {
      Array.from(
        document.querySelectorAll(
          `[data-variant-option="true"][value=${optionSelector}]`
        )
      ).forEach((relatedOptionSelector) => {
        relatedOptionSelector.click();
      });
    }
  }
}

if (!customElements.get("product-item-variant-selector")) {
  customElements.define("product-item-variant-selector", ProductVariantSelects);
}

class ProductOptions extends HTMLElement {
  constructor() {
    super();
    this.root = this.closest("product-item-variant-selector");
    this.optionName = this.dataset.optionName;
    if (!(this.dataset.ignoreLabel === "true")) {
      this.labelValues = this.querySelectorAll(
        "[data-option-value]:not([data-ignore-change])"
      );
    }
    this.productInfoWrapper = this.closest("main-product");
    this.addListeners();
    this.initSelectedOptionFromQuery();
    this.initialiseBwp();

    this.updateSwatchTitles();
  }
  initialiseBwp() {
    if (!this.productInfoWrapper) return;
    this.hasSubscription = this.productInfoWrapper.querySelector(
      "[data-subscription-option]"
    );
    const inputOtp = this.productInfoWrapper.querySelector(
      'input[id^="otp-option"]'
    );
    let isOtpSelected = inputOtp && inputOtp.checked;
    if (this.productInfoWrapper) {
      this.productInfoWrapper.toggleAttribute(
        "data-is-otp-selection",
        isOtpSelected
      );
    }
    if (!this.hasSubscription) {
      isOtpSelected = true;
    }
    const elementBwP = this.productInfoWrapper.querySelector(
      ".delivery-promise__promise-container"
    );
    if (elementBwP) {
      elementBwP.style.cssText = isOtpSelected
        ? "display: block"
        : "display: none !important";
    }

    // While experiment is running, this will override the display property using !important
    if (isOtpSelected) {
      triggerExperiment("EXP_20240124_buy_prime");
    }
  }

  selectOptionByValue(optionKey) {
    const optionValue =
      theme.translations.option_values[optionKey] ||
      theme.translations.option_values_map[optionKey];
    const options = this.querySelectorAll(`[value="${optionValue}"]`);
    options.forEach((option) => {
      option.click();
      this.setAttribute("data-option-set-from-query", true);
    });
  }

  initSelectedOptionFromQuery() {
    try {
      window.addEventListener("load", () => {
        const params = new URLSearchParams(window.location.search);
        this.selectOptionByValue(params.get("skin_type")); // We can add others as needed
        this.selectOptionByValue(params.get("color"));
        this.selectOptionByValue(params.get("trimmer_type"));
        this.selectOptionByValue(params.get("shade"));
      });
    } catch (error) {
      // swallow
    }
  }

  updateSwatchTitles() {
    const checked = this.querySelector('input[type="radio"]:checked');
    if (!checked) return;

    const val = checked.value.trim().toLowerCase();
    const PATTERN_VALUES = ["forest", "arctic"];

    const colorTitle = this.querySelector(
      "[data-option-value]:not([data-option-value-pattern])"
    );
    const patternTitle = this.querySelector(
      "[data-option-value][data-option-value-pattern]"
    );

    if (!colorTitle || !patternTitle) return;

    if (PATTERN_VALUES.includes(val)) {
      colorTitle.classList.add("hidden");
      patternTitle.classList.remove("hidden");
    } else {
      colorTitle.classList.remove("hidden");
      patternTitle.classList.add("hidden");
    }
  }

  addListeners() {
    if (this.labelValues) {
      this.addEventListener("change", (evt) => {
        this.handleImageLoader(evt);
        this.querySelectorAll(
          ".product-options__subscription-option-wrapper"
        ) &&
          this.querySelectorAll(
            ".product-options__subscription-option-wrapper"
          ).forEach((node) => node.classList.remove("active"));
        if (
          this.productInfoWrapper &&
          this.productInfoWrapper.querySelectorAll(
            ".product-options__subscription-option-wrapper"
          ).length > 1
        ) {
          const checkedOption = Array.from(
            this.productInfoWrapper.querySelectorAll(
              ".product-options__subscription-option-wrapper"
            )
          ).find((el) =>
            el.querySelector(
              'input:checked[data-type="option"]:not([data-simple=true])'
            )
          );
          checkedOption && checkedOption.classList.add("active");
        } else if (
          evt.target.closest(".product-options__subscription-option-wrapper")
        ) {
          evt.target
            .closest(".product-options__subscription-option-wrapper")
            .classList.add("active");
        }
        this.initialiseBwp();
        this.labelValues.forEach((j) => {
          const value = evt.target.value;
          const valueKey = value.toLowerCase().replace(" ", "_");
          const translatedLabel = theme.translations.option_values[valueKey];
          j.innerHTML = translatedLabel || value;
        });

        this.updateSwatchTitles();
      });
    }
  }
  handleImageLoader(evt) {
    if (this.root) {
      this.root.classList.add("changing-variant");
      this.productCardImage = this.root.querySelector(".product-card__image");
      this.productCardImage &&
        this.productCardImage.addEventListener(
          "load",
          () => {
            setTimeout(() => {
              this.root.classList.remove("changing-variant");
            }, 600);
          },
          { once: true }
        );
      const bg_color =
        evt.target.value && theme.shop.background_colors_map
          ? theme.shop.background_colors_map[evt.target.value.toLowerCase()] ||
            ""
          : "";
      if (bg_color && this.root.classList.contains("alt-bg-design")) {
        this.root.style.background = bg_color;
      }
    }
  }
}

customElements.define("product-options", ProductOptions);
class SubscriptionProgramV2 extends HTMLElement {
  constructor() {
    super();
    if (document.body.dataset.grp) {
      if (this.dataset.hide === "true") {
        this.removeAttribute("data-hide");
      } else if (this.parentElement.children.length > 1) {
        this.remove();
        return;
      }
    } else if (
      this.dataset.hide === "true" &&
      this.parentElement.children.length > 1
    ) {
      this.remove();
      return;
    }
    this.loadInitialAccordionData();

    this.defaultSubscriptionOption =
      this.dataset.defaultSubscriptionOption === "subscription";
    this.modal = this.closest("#Cart-upsell-grp-modal");
    this.cartGrpModal =
      this.modal && this.modal.querySelector("[data-cart-grp-modal]");
    this.formText =
      this.modal && this.modal.querySelector(".product-form__submit");
    const priceContainerArray = document.querySelectorAll(
      "[data-current-price]"
    );
    const variantPrice = this.dataset.productPrice * 1;
    priceContainerArray.forEach((priceContainer) => {
      priceContainer.innerText = formatMoney(variantPrice);
    });
    const stickyPDP = document.querySelector("pdp-add-to-cart");
    stickyPDP && stickyPDP.classList.remove("pdp-add-to-cart--enabled");
    this.data = this.querySelector("#sub-program-json");
    this.dataArray = JSON.parse(this.data.textContent);
    this.consumablesSubPrice = this.querySelector(
      "[data-consumables-price-sub]"
    );
    this.productPrice = this.dataset.productPrice;
    this.comparePrice = this.dataset.comparePrice || this.productPrice;
    this.mainProduct =
      this.closest("product-item-variant-selector") ||
      this.closest("main-product");

    if (this.mainProduct) {
      this.savePercentageContainer = this.mainProduct?.querySelector(
        "[data-save-percent-container]"
      );
      this.savePercentage =
        this.savePercentageContainer &&
        this.savePercentageContainer.querySelector(
          "[data-save-percent-program]"
        );
      this.otpPriceContainer = this.mainProduct?.querySelector(
        ".grp-price[data-otp]"
      );
      this.grpPriceWrapper = this.mainProduct?.querySelector(
        ".grp-price__wrapper"
      );
      this.offerPriceContainerArray = this.mainProduct?.querySelectorAll(
        "[data-current-price]"
      );
      this.grpOptionRecurringPrice = this.mainProduct?.querySelectorAll(
        "[data-prices-discounted]"
      );
      this.recurringContainer = this.querySelector("[data-recurring]");
    }
    this.selectedProgramHandleInput = this.querySelector(
      'input[name="properties[_subscription-program-handle]"]'
    );
    this.selectedSellingPlanFiltersInput = this.querySelector(
      'input[name="properties[_selling-plan-filter-array]"]'
    );
    this.selectedVariantsIdsInput = this.querySelector(
      'input[name="properties[_subscription-program-ids]"]'
    );
    this.selectedSellingPlansInput = this.querySelector(
      'input[name="properties[_subscription-program-selling-plans]"]'
    );
    this.showMore = this.querySelector(".sub-prog-select__show-more");
    this.showLess = this.querySelector(".sub-prog-select__show-less");
    this.labelsArr = this.querySelectorAll(
      ".sub-prog-select__item, .sub-program--alternate__label"
    );
    this.alternateProgram = this.querySelector(".sub-program--alternate__wrap");
    this.updateForm(
      !this.defaultSubscriptionOption,
      this.defaultSubscriptionOption
        ? this.labelsArr[0]
        : this.labelsArr[this.labelsArr.length - 1]
    );
    this.firstCarouselPreviewImage = this.mainProduct.querySelector(
      ".carousel-first-preview__image"
    );
    this.firstCarouselThumbnailImage = this.mainProduct.querySelector(
      ".carousel-first-thumbnail__image"
    );
    this.subscriptionImages = this.mainProduct.querySelectorAll(
      ".subscription-preview__image"
    );
    this.labelsArr.forEach((item) => {
      item.addEventListener("click", (e) => {
        this.updateForm(!!item.dataset.noAddons, e.currentTarget);
        this.labelsArr.forEach((label) => {
          label.classList.remove("active");
        });
        this.changeMediaSubscription(item);
        item.classList.add("active");
        if (this.alternateProgram) {
          this.labelsArr.forEach((label) => {
            if (!label.classList.contains("active")) {
              const inputId = label.getAttribute("for");
              const input = document.getElementById(inputId);
              if (input) input.checked = false;
            }
          });
        }
      });
    });
    this.delayedVariants = this.dataset.delayedVariants;
    this.currentId = this.dataset.variantId;
    this.variantPriceContainer = this.querySelector("[data-variant-price-otp]");
    this.calculatePrices();
    this.addOtpPPriceEvent();
  }

  connectedCallback() {
    this.changeMediaSubscription("reset");
    if (!this.defaultSubscriptionOption) {
      this.grpPriceWrapper && this.grpPriceWrapper.classList.add("active");
    }
    if (this.classList.contains("sub-program--alternate")) return;
    if (this.modal) {
      setTimeout(() => {
        this.initializeAnimation();
      }, 300);
    } else {
      this.initializeAnimation();
    }
  }
  addOtpPPriceEvent() {
    this.mainProduct.addEventListener("variant-change", (e) => {
      const newPrice = e.detail.currentVariant.price;
      if (this.productPrice == newPrice) return;
      this.productPrice = newPrice;
      this.comparePrice = e.detail.currentVariant.compare_at_price;
      if (this.variantPriceContainer) {
        this.variantPriceContainer.innerText = formatMoney(newPrice);
      }
      this.calculatePrices();
    });
  }
  initializeAnimation() {
    this.optionsWrap = this.querySelector(".sub-prog__wrap");
    this.optionsContainer = this.querySelector(".sub-prog__container");
    this.optionsWrapHeight = this.optionsWrap.offsetHeight;
    this.optionsWrap.style.height = this.optionsWrapHeight + "px";
    this.labelsArr.forEach((label) => (label.style.display = "flex"));
    this.optionsContainerHeight = this.optionsContainer.offsetHeight;
    this.showMore &&
      this.showMore.addEventListener("click", () =>
        this.animateOptionsWrap(this.optionsContainerHeight)
      );
    this.showLess &&
      this.showLess.addEventListener("click", () =>
        this.animateOptionsWrap(this.optionsWrapHeight)
      );
    if (this.dataset.preorder === "true") {
      this.style.display = "none";
      this.querySelector("input[id^='otp-option-']") &&
        this.querySelector("input[id^='otp-option-']").click();
      this.style.visibility = "visible";
    }
  }
  animateOptionsWrap(height) {
    this.optionsWrap.classList.add("animating");
    this.optionsWrap.style.height = height + "px";
    this.optionsWrap.classList.toggle("active");
    setTimeout(() => {
      this.optionsWrap.classList.remove("animating");
    }, 200);
  }

  updateForm(reset = false, element) {
    const selectedColor = this.mainProduct?.querySelector(
      "[data-color]:checked"
    );
    if (selectedColor) {
      const selectedColorValue = selectedColor.value;
      this.labelsArr.forEach((label) => {
        label.classList.remove("disabled-addon");
      });
      this.dataArray.forEach((array, i) => {
        array.forEach((object, j) => {
          let filteredColor = selectedColorValue;
          if (selectedColorValue === "ARCTIC") {
            filteredColor = "ONYX";
          }
          if (selectedColorValue === "FOREST") {
            filteredColor = "SAGE";
          }
          const variantData = object[filteredColor];

          if (Object.keys(object).length && variantData) {
            const input = this.labelsArr[i].querySelector("input");
            const img = this.labelsArr[i].querySelectorAll("img")[j];
            if (img) {
              img.src = variantData.src;
              img.removeAttribute("srcset");
            }
            const replaceID = input.dataset.ids.split(";")[j];
            input.dataset.ids = input.dataset.ids.replace(
              replaceID,
              variantData.id
            );
            if (variantData.in_stock === "false" || !variantData.id) {
              const label = this.labelsArr[i];
              if (label.classList.contains("active"))
                this.labelsArr[i + 1].click();
              label.classList.add("disabled-addon");
            }
          }
        });
      });
    }
    element && (this.element = element);
    this.selectedOffer = this.element.querySelector("input");
    if (this.mainProduct) {
      const isOtpSelected =
        this.selectedOffer && this.selectedOffer.id.includes("otp");
      this.mainProduct.toggleAttribute("data-is-otp-selection", isOtpSelected);
    }
    this.changeIncludedAccordeon(this.selectedOffer.dataset.titles);
    if (reset) {
      this.selectedProgramHandleInput.value = "";
      this.selectedSellingPlanFiltersInput.value = "";
      this.selectedVariantsIdsInput.value = "";
      this.selectedSellingPlansInput.value = "";
      this.calculatePrices();
      if (this.comparePrice === this.productPrice) {
        this.grpPriceWrapper &&
          this.grpPriceWrapper.classList.add("full-price");
      }
      return;
    }
    if (
      this.selectedOffer.dataset.discountedPrice &&
      this.consumablesSubPrice
    ) {
      this.consumablesSubPrice.innerText = formatMoney(
        this.selectedOffer.dataset.discountedPrice * 1
      );
    }

    if (
      !this.selectedOffer.dataset.subHandle ||
      !this.selectedOffer.dataset.sellingPlanFilter
    )
      return;
    this.selectedVariantsIdsInput.value = this.selectedOffer.dataset.ids;
    this.selectedSellingPlansInput.value =
      this.selectedOffer.dataset.sellingPlan;
    this.selectedProgramHandleInput.value =
      this.selectedOffer.dataset.subHandle;
    this.selectedSellingPlanFiltersInput.value =
      this.selectedOffer.dataset.sellingPlanFilter;
    this.grpPriceWrapper && this.grpPriceWrapper.classList.add("active");
    this.calculatePrices();
  }
  changeMediaSubscription(item) {
    if (
      !this.firstCarouselThumbnailImage ||
      !this.firstCarouselPreviewImage ||
      !this.subscriptionImages ||
      !this.subscriptionImages.length
    )
      return;

    let showSubs = false;
    let showOrig = false;

    if (item === "reset") {
      showSubs = true;
    } else if (item && item.nodeType === 1) {
      if (item.classList.contains("sub")) showSubs = true;
      else if (item.classList.contains("otp")) showOrig = true;
      else return;
    } else {
      return;
    }

    this.firstCarouselThumbnailImage.classList.toggle("hidden", showSubs);
    this.firstCarouselPreviewImage.classList.toggle("hidden", showSubs);

    (this.subscriptionImages.forEach
      ? this.subscriptionImages
      : Array.from(this.subscriptionImages)
    ).forEach((img) => img.classList.toggle("hidden", showOrig));
  }

  calculatePrices() {
    const otpPrice =
      this.selectedOffer.dataset.variantPrice * 1 + this.comparePrice * 1;
    let discountedPrice =
      this.productPrice * 1 + this.selectedOffer.dataset.prices * 1;
    if (this.selectedOffer.dataset.programPrice) {
      discountedPrice = Number(this.selectedOffer.dataset.programPrice);
    }
    if (this.otpPriceContainer) {
      if (discountedPrice != otpPrice) {
        this.grpPriceWrapper &&
          this.grpPriceWrapper.classList.remove("full-price");
      } else {
        this.grpPriceWrapper &&
          this.grpPriceWrapper.classList.add("full-price");
      }
      this.otpPriceContainer.innerText = formatMoney(otpPrice);
      const save = Math.round(100 - (discountedPrice / otpPrice) * 100);
      if (save > 0) {
        if (this.savePercentageContainer) {
          this.savePercentage.innerText = save;
          this.savePercentageContainer.classList.remove("hidden");
        }
        this.grpPriceWrapper &&
          this.grpPriceWrapper.classList.remove("full-price");
      } else {
        this.savePercentageContainer?.classList?.add("hidden");
        this.grpPriceWrapper &&
          this.grpPriceWrapper.classList.add("full-price");
      }

      const comparePriceButton = this.closest("main-product")?.querySelector(
        "[data-product-compare-price]"
      );
      if (
        comparePriceButton &&
        this.selectedOffer.dataset.variantPrice !== "0"
      ) {
        comparePriceButton.innerText = formatMoney(otpPrice);
      } else if (this.comparePrice !== this.productPrice) {
        comparePriceButton.innerText = formatMoney(this.comparePrice * 1);
      } else {
        if (comparePriceButton) {
          comparePriceButton.classList.add("hidden");
        }
      }
    }
    if (this.offerPriceContainerArray) {
      this.offerPriceContainerArray.forEach((offerPrice) => {
        if (this.cartGrpModal) {
          const offerValue = this.selectedOffer.dataset.prices * 1;
          if (offerValue) {
            this.formText.classList.remove("free");
            offerPrice.innerText = formatMoney(offerValue);
          } else {
            this.formText.classList.add("free");
          }
        } else {
          offerPrice.innerText = formatMoney(discountedPrice);
        }
      });
    }
    if (this.grpOptionRecurringPrice) {
      this.grpOptionRecurringPrice.forEach((recurringPriceContainer) => {
        let recurringPrice = this.selectedOffer.dataset.priceDiscounted * 1;
        if (!recurringPrice) {
          this.recurringContainer?.classList.add("hidden");
        } else {
          this.recurringContainer?.classList.remove("hidden");
        }
        recurringPriceContainer.innerHTML = formatMoney(recurringPrice);
      });
    }
  }

  loadInitialAccordionData() {
    this.accordion = document.querySelector(
      "[data-value='what_it_is_in_box'] .metafield-rich_text_field, [data-value='whatsIncluded'] .benefits-wrapper"
    );
    if (this.accordion) {
      this.innitialAccoridionData = this.accordion.innerHTML;
    }
  }

  //Changes what's in the box accordion to also include the add ons products;
  changeIncludedAccordeon(titles) {
    if (!this.accordion) return;
    this.accordion.innerHTML = this.innitialAccoridionData;

    if (!titles) return;

    const splitTitles = titles.split(";");
    const parentNode = this.accordion.firstChild;

    splitTitles.forEach((title) => {
      if (!parentNode) return;

      const isEmptyUl = parentNode.children.length === 0;

      const referenceNode = isEmptyUl ? parentNode : parentNode.firstChild;
      const clone = referenceNode.cloneNode();
      clone.textContent = clone.nodeName === "LI" ? title : `• ${title}`;

      parentNode.appendChild(clone);
    });
  }
}
customElements.define("subscription-program-v2", SubscriptionProgramV2);

class SimpleVariantListener extends HTMLElement {
  constructor() {
    super();
    this.variantUpdateInputSelector = this.dataset.variantInputSelector;
    this.currentId = this.dataset.variantId;
    this.inputAttribute = this.dataset.inputAttribute;
  }
  connectedCallback() {
    this.input = document.querySelector(this.variantUpdateInputSelector);
    this.subscriptionProgramV2 = this.closest("subscription-program-v2");
    try {
      const script = this.querySelector('script[type="application/json"]');
      this.jsonObject = JSON.parse(script.innerText);
    } catch (e) {
      this.jsonObject = {};
    }
    this.addListeners();
  }
  addListeners() {
    this.addEventListener("change", (evt) => {
      evt.stopImmediatePropagation();
      const value = evt.target.value;
      const newVariantId = this.jsonObject[value];
      if (newVariantId) {
        this.handleInputChange(newVariantId);
      }
    });
  }

  handleInputChange(newVariantId) {
    if (!this.input || !newVariantId) return;
    let currentValue = this.input.textContent;
    if (this.inputAttribute) {
      currentValue = this.input.getAttribute(this.inputAttribute);
      this.input.setAttribute(
        this.inputAttribute,
        currentValue.replace(this.currentId, newVariantId)
      );
    } else {
      this.input.textContent = currentValue.replace(
        this.currentId,
        newVariantId
      );
    }
    this.currentId = newVariantId;
    if (this.subscriptionProgramV2) {
      this.subscriptionProgramV2.updateForm();
    }
  }
}
customElements.define("simple-variant-listener", SimpleVariantListener);

class SubscriptionIntervalSelector extends HTMLElement {
  constructor() {
    super();
    this.optionSelect = this.querySelector(
      "select.product-options__interval-select"
    );
    this.parent = this.closest("main-product")
      ? this.closest("main-product")
      : this.closest("product-item-variant-selector");
    this.addEventListener("change", (evt) => {
      evt.stopImmediatePropagation();
      this.parent.overrideSubscriptionInterval(
        Number.parseInt(evt.target.value),
        evt.target.value
      );
    });
  }
  updateIntervalValue(evt, selectedVariant) {
    let targetElement = evt.target.closest("product-options");
    if (
      targetElement &&
      targetElement.getAttribute("data-size-option") &&
      targetElement.getAttribute("data-size-option") === "true"
    ) {
      this.optionSelect.value = selectedVariant.subscription_interval_type;
    }
  }
}
customElements.define(
  "subscription-interval-selector",
  SubscriptionIntervalSelector
);
